import React, { useState } from "react";
import { Tab } from '@headlessui/react'
import { TitleComponent } from '../../components/pages/index'
import { useChangeDocTitle } from '../../hooks/index';
import SurveyAnswer from './SurveyAnswers';
import "./Main.css"

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Dashboard = props => {
    useChangeDocTitle('Dashboard');
    /* let [tabs] = useState([
        {
            name:'Encuestas - Respuestas',
            component :<SurveyAnswer />
        }
    ]) */

    return (
        <div className="dash select-none">
            <h1>Bienvenido(a) a la plataforma recopiladora de reportes LOCK Y ASOCIADOS</h1>
            {/* <img src={logo}/> */}

            {/* <TitleComponent title="Dashboard" />
            <div>
                <div className="w-full px-2 py-4 sm:px-0">
                    <Tab.Group>
                        <Tab.List className="flex p-1 space-x-1 bg-blue-900/20 rounded-xl">
                            {tabs.map((tab, index) => (
                                <Tab key={'tab_' + index}
                                    className={({ selected }) =>
                                        classNames('w-full py-2.5 text-sm leading-5 font-medium text-primary rounded-lg',
                                            'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-900 ring-white ring-opacity-60',
                                            selected ? 'bg-white shadow' : 'text-blue-100 hover:bg-red-700 hover:text-white'
                                        )
                                    }
                                >
                                    {tab.name}
                                </Tab>
                            ))}
                        </Tab.List>
                        <Tab.Panels className="mt-3">
                            {tabs.map((tab, idx) => (
                                <Tab.Panel key={'panel_' + idx}>
                                    {tab.component}
                                </Tab.Panel>
                            ))}
                        </Tab.Panels>
                    </Tab.Group>
                </div>
            </div> */}
        </div>
    )
}

export default Dashboard;